import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import {
  DataProvider,
  ParameterProvider,
  ServiceProvider,
  useTheme,
} from "contexts";
import { Common } from "components";
import { LoadData } from "middlewares";
import { ScrollToTop } from "components/page";

export const DefaultLayout = () => {
  const { theme } = useTheme();

  return (
    <ParameterProvider>
      <ServiceProvider>
        <DataProvider>
          <ScrollToTop />
          <LoadData>
            <Common.Navbar />
            <Box
              component="main"
              bgcolor={theme.color.background.color}
              pt={theme.component.layout.navbar.height / theme.spacing.factor}
            >
              {/* <Box sx={{ display: "grid", flexGrow: 1 }}> */}
              <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                <Outlet />
              </Box>
              <Common.Footer />
            </Box>
            <Common.Message />
          </LoadData>
        </DataProvider>
      </ServiceProvider>
    </ParameterProvider>
  );
};
